import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'

import {
  GET_CLUBS, CREATE_LIVE_SCHEDULE, GET_LIVE_SCHEDULES, DELETE_SCHEDULE, GET_SCHEDULE, UPDATE_SCHEDULE, RESET_SCHEDULE_STATE
} from './actions.type'
import {
  SET_CLUBS_FOR_SCHEDULE,
  SET_ERROR,
  SET_IS_LOADING,
  SET_CREATED_LIVE_SCHEDULE,
  SET_LIVE_SCHEDULES,
  SET_DELETED_SCHEDULE,
  RESET_STATE,
  SET_LIVE_SCHEDULE
} from './mutations.type'

export const getDefaultState = () => {
  return {
    clubs: [],
    schedules: [],
    totalPage: 1,
    isLoading: false,
    schedule: null,
    error: null
  }
}

const state = getDefaultState()

const getters = {}

const actions = {
  [GET_CLUBS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/clubs')
        .then(({ data }) => {
          context.commit(SET_CLUBS_FOR_SCHEDULE, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response)
          reject(response)
        })
    })
  },
  [CREATE_LIVE_SCHEDULE](context, { league, startedAt, homeClubId, awayClubId }) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      const user = JSON.parse(JwtService.getUser())
      ApiService.post('api/v1/live-schedules', {
        league: league,
        startedAt: startedAt,
        homeClubId: homeClubId,
        awayClubId: awayClubId,
        streamerId: user.streamerId
      })
        .then(({ data }) => {
          context.commit(SET_CREATED_LIVE_SCHEDULE, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_LIVE_SCHEDULES](context, page) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/live-schedules', '?limit=10&page=' + page)
        .then(({ data }) => {
          context.commit(SET_LIVE_SCHEDULES, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_SCHEDULE](context, id) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.get(`api/v1/live-schedules/${id}`)
        .then(({ data }) => {
          context.commit(SET_LIVE_SCHEDULE, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [UPDATE_SCHEDULE](context, { id, league, startedAt, homeClubId, awayClubId }) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      const user = JSON.parse(JwtService.getUser())
      ApiService.put(`api/v1/live-schedules/${id}`, {
        league: league,
        startedAt: startedAt,
        homeClubId: homeClubId,
        awayClubId: awayClubId,
        streamerId: user.streamerId
      })
        .then(({ data }) => {
          context.commit(SET_CREATED_LIVE_SCHEDULE, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [DELETE_SCHEDULE](context, schedule) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.delete(`api/v1/live-schedules/${schedule.id}`)
        .then(({ data }) => {
          context.commit(SET_DELETED_SCHEDULE, schedule)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [RESET_SCHEDULE_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
  [SET_ERROR](state, error) {
    state.errors = error
    state.isLoading = false
  },
  [SET_CLUBS_FOR_SCHEDULE](state, response) {
    if (response) {
      state.clubs = response.sort((a, b) => (a.clubName > b.clubName) ? 1 : ((b.clubName > a.clubName) ? -1 : 0))
    }
    state.isLoading = false
    state.error = null
  },
  [SET_CREATED_LIVE_SCHEDULE](state, response) { },
  [SET_LIVE_SCHEDULES](state, response) {
    state.schedules = response.data
    state.totalPage = response.meta.lastPage
    state.isLoading = false
    state.error = null
  },
  [SET_LIVE_SCHEDULE](state, response) {
    state.schedule = response
    state.isLoading = false
    state.error = null
  },
  [SET_DELETED_SCHEDULE](state, schedule) {
    state.schedules.splice(state.schedules.indexOf(schedule), 1)
    state.isLoading = false
    state.error = null
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
